const OBSTACLES = {
  CACTUS_LARGE: {
    animation: 'CACTUS_LARGE',
    width: 50,
    height: 105,
    spriteX: 652,
    spriteY: 2
  },
  CACTUS_SMALL: {
    animation: 'CACTUS_SMALL',
    width: 70,
    height: 90,
    spriteX: 446,
    spriteY: 2
  },
  PTERODACTYL: {
    animation: 'PTERODACTYL',
    width: 90,
    height: 100,
    spriteX: 260,
    spriteY: 2
  }
};

export default OBSTACLES;
